import { createGLBModel } from "./GLBModel";

import { computeCurvatureDirections } from "../../geometry/computeCurvatureDirections";

import dragonUrl from "../../../../assets/models/DragonAttenuation.glb";

const DragonModel = createGLBModel({
  id: "dragon",

  name: "Stanford Dragon",

  url: dragonUrl,

  transform: {
    position: [0, 0, 0],

    rotation: [0, 0, 0],

    scale: 1.0,
  },

  capabilities: {
    normals: true,
    uv: true,
    tangents: false,
  },

  geometryProcessor: computeCurvatureDirections,
});

export default DragonModel;
